class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

window.addEventListener("load", function () {
    $(".btn-top").on("click", function () {
        // scroll to top
        $("html, body").animate({
            scrollTop: 0
        }, "fast");
    });
});